import once from 'lodash/once';
import { createContext, useContext } from 'react';

import type { IContext } from './models';

export const initialContext: IContext = {
    route: '',
    switchRoute: (route: string) => route,
};

export const createRouterContext = once(<S>() =>
    createContext<IContext<S>>(initialContext as unknown as IContext<S>)
);

export const useRouterContext = <S = string>() => useContext(createRouterContext<S>());
